/* @flow */
import TrackingUtil from "../../src/utils/TrackingUtil";
import { isNil } from "./util";

const MAX_SIZE = 1000;

let dataMap: { [k: string]: any } = {};

let ringBuffer: string[] = [];

export function get(key: string | undefined | null) {
    if (!key) {
        return undefined;
    }
    const element = dataMap[key];
    if (!isNil(element)) {
        const now = new Date();
        if (now.getTime() < element.timeout.getTime()) {
            return element.data;
        } else {
            deleteElement(key);
        }
    }
    return undefined;
}

export function getAll(idList: string[]) {
    const resultMap: { [k: string]: any } = {};
    const resultIds: string[] = [];
    (idList ?? []).forEach((id) => {
        const value = get(id);
        if (!isNil(value)) {
            resultMap[id] = value;
            resultIds.push(id);
        }
    });
    const result = {
        ids: resultIds,
        data: resultMap
    };
    return result;
}

export function put(key: string | undefined | null, value: any, ttlInSeconds: number = 600) {
    if (!key || !value) {
        return;
    }
    if (!Number.isFinite(ttlInSeconds) || ttlInSeconds <= 0) {
        TrackingUtil.trackUiErrorSd("ArticleCache", "Invalid ttl in ArticleCache.put:" + ttlInSeconds);
        return;
    }
    if (size() > MAX_SIZE) {
        removeStaleObjects();
        if (size() > MAX_SIZE) {
            shrink();
        }
    }
    const now = new Date();
    const timeout = new Date(now.getTime() + ttlInSeconds * 1000);
    const element = {
        data: value,
        timeout
    };
    dataMap[key] = element;
    ringBuffer.push(key);
}

export function deleteElement(key: string | undefined | null) {
    if (!key) {
        return;
    }
    delete dataMap[key];
    const index = ringBuffer.indexOf(key);
    ringBuffer.splice(index, 1);
}

export function removeStaleObjects() {
    Object.entries(dataMap).forEach(([key, value]) => {
        const now = new Date();
        if (now.getTime() > value.timeout.getTime()) {
            deleteElement(key);
        }
    });
}

export function shrink(shrinkSize: number = 20) {
    const keysToRemove = ringBuffer.splice(0, shrinkSize);
    keysToRemove.forEach((key) => {
        delete dataMap[key];
    });
}

export function clear() {
    dataMap = {};
    ringBuffer = [];
}

export function size() {
    return Object.keys(dataMap).length;
}
